import { css } from '@emotion/css';

export const objectFitCoverCss = css`
  object-fit: cover;
`;
